import * as React from 'react';
import { Form, Input } from 'antd';
import { FormWidgetItem } from './wrapper/FormWidgetItem';
import { IWidget } from 'common/schema/widget/Widget';
import { getWidgetInputViewType } from '../helper/getWidgetInputViewType';
import { WidgetInputViewType } from 'common/schema/widget/input/WidgetInputViewType';
import { MetadataLogic } from 'common/schema/metadata/MetadataLogic';
import { TextInput } from 'client/ui/form/input/TextInput';
import { useFormWidgetProps } from './contextual/useFormWidgetProps';
import { metadataSuffix, SuffixType } from '../helper/metadataSuffix';
import { useMailHelp } from '../repository/input-email/useMailHelp';

export interface FormWidgetInputEmailViewProps {
  widget: IWidget;
}

export function FormWidgetInputEmailView(props: FormWidgetInputEmailViewProps) {
  const { widget } = props;

  // Abbiamo un singolo metadato per i campi di testo
  const metadata = MetadataLogic.singleFromWidget(widget);
  const name = `values.${metadata.id}`;
  const confirmName = `values.${metadataSuffix(
    metadata.id,
    SuffixType.Confirm
  )}`;

  const [inputProps] = useFormWidgetProps(widget);
  const mailHelpProps = useMailHelp(metadata);

  if (getWidgetInputViewType(props.widget) === WidgetInputViewType.EmailCheck) {
    return (
      <>
        <FormWidgetItem name={name} widget={props.widget} {...mailHelpProps}>
          <TextInput
            name={name}
            type="email"
            placeholder={widget.input?.placeholder}
            {...inputProps}
          />
        </FormWidgetItem>
        {/* TODO: gestire label e  placeholder del campo ripeti email */}
        <FormWidgetItem
          name={confirmName}
          widget={props.widget}
          label="Ripeti Email"
        >
          <TextInput
            name={confirmName}
            type="email"
            placeholder="Ripeti Email per Conferma"
            {...inputProps}
          />
        </FormWidgetItem>
      </>
    );
  }
  return (
    <FormWidgetItem name={name} widget={props.widget} {...mailHelpProps}>
      <TextInput
        name={name}
        type="email"
        placeholder={widget.input?.placeholder}
        {...inputProps}
      />
    </FormWidgetItem>
  );
}
